module.exports = __webpack_public_path__ + "img/MGH-Gaien-10-2440x1172.57ac1d70.jpg";